const paymentDetailsStyles = (theme) => ({
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      overflow: "hidden",
      backgroundColor: theme.palette.mode === "light" ? "#f0f0f0" : "#333", 
    },
    box: {
      padding: 4,
      bgcolor: theme.palette.mode === "light" ? "white" : "#424242", 
      boxShadow: 3,
      borderRadius: 2,
      minWidth: 300,
      textAlign: "center",
      color: theme.palette.mode === "light" ? "#000" : "#fff", 
    },


  });
  

  
  export default paymentDetailsStyles;
  